export function addPrefix(rawUrl) {
	let apiUrl;
	if (process.env.VUE_APP_CONFIG == "development") {
		apiUrl = process.env.VUE_APP_API_DEVELOPMENT;
	} else {
		apiUrl = process.env.VUE_APP_API_PRODUCTION;
	}
	if (String(rawUrl).includes("http")) {
		return rawUrl
	}
	return apiUrl + '/' + rawUrl;
}